import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { API_ENDPOINTS } from '../constants/api-endpoints.constants';
import {
	LoginData,
	LoginResponse,
	SignupData
} from '../interface/user.interface';
const BASE_URL = environment.apiBaseUrl;

@Injectable({
	providedIn: 'root'
})
export class UserService {
  //token: string = String(localStorage.getItem('auth'))

	constructor(private http: HttpClient) {}

	login(loginData: LoginData): Observable<LoginResponse> {
		let { email, password } = loginData;
		const url = `${BASE_URL}${API_ENDPOINTS.LOGIN}`;

		return this.http.post<any>(url, {
			du_email_id: email,
			du_password: password
		});
	}

	logOut(email: string | null): Observable<any> {
		const url = `${BASE_URL}${API_ENDPOINTS.LOGOUT}`;

		return this.http.post<any>(url, {
			email_id: email
		});
	}

	signup(signupData: SignupData): Observable<any> {
		let {
			familyCode,
			contactNo,
			firstName,
			lastName,
			emailAddress,
			password,
			address,
			pincode,
			state,
			district
		} = signupData;
		const url = `${BASE_URL}${API_ENDPOINTS.SIGNUP}`;

		return this.http.post<any>(url, {
			du_family_code: familyCode,
			du_contact_number: contactNo,
			du_first_name: firstName.toUpperCase(),
			du_last_name: lastName.toUpperCase(),
			du_email_id: emailAddress,
			du_password: password,
			du_address: address,
			du_pincode: pincode,
			du_state_name: state,
			du_district_name: district,
			du_created_by:
				firstName.toUpperCase() + ' ' + lastName.toUpperCase()
		});
	}

  get getToken(){
    return sessionStorage.getItem('auth')
  }

  get getTokenDetails(){
    let tokenDTLS = JSON.parse(atob(String(sessionStorage.getItem('auth')).split('.')[1]))
	console.log("tokendetails",tokenDTLS)
    return tokenDTLS
  }
}
